import { render, staticRenderFns } from "./com-upload.vue?vue&type=template&id=156711c3&scoped=true&"
import script from "./com-upload.vue?vue&type=script&lang=js&"
export * from "./com-upload.vue?vue&type=script&lang=js&"
import style0 from "./com-upload.vue?vue&type=style&index=0&id=156711c3&prod&lang=scss&scoped=true&"
import style1 from "./com-upload.vue?vue&type=style&index=1&id=156711c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156711c3",
  null
  
)

export default component.exports